import React from "react";
import { Button, makeStyles } from "@material-ui/core";
import { connect } from "react-redux";
import { hasRoutePermission } from "shared/utils";

function KisshtButton({
  role,
  route,
  permission,
  dispatch,
  variant,
  color,
  id,
  size,
  ...rest
}) {
  // Dynamic Color
  //let colorCode = '#1D44E9'; // Default color code as per new desin
  let colorCode = "#526DFF";

  let backgroundColorCode = "transparent";

  if (color == "error") {
    colorCode = "#D90429";
  } else if (color == "black") {
    colorCode = "#131523";
  } else if (color == "success") {
    colorCode = "#327B3D";
  }

  let borderColorCode = colorCode;

  if (variant == "contained") {
    backgroundColorCode = colorCode;
    colorCode = "#ffffff";
  } else if (variant == "contained-bg-white") {
    backgroundColorCode = "#ffffff";
  } else if (variant == "text") {
    borderColorCode = "transparent";
  }

  // Dynamic Size
  let fontSize = "13px";
  let height = "1.9rem";
  let padding = "8px";

  if (size == "md") {
    fontSize = "14px";
    height = "2.3rem";
    padding = "15px";
  }

  const useStyles = makeStyles((theme) => ({
    button: {
      // [theme.breakpoints.down("lg")]: {
        "& .MuiButton-root": {
          color: `${colorCode}`,
          border: `1px solid ${borderColorCode}`,
          backgroundColor: `${backgroundColorCode}`,
          borderRadius: "8px",
          padding: `${padding}`,
          fontSize: `${fontSize}`,
          lineHeight: "16px",
          height: `${height}`,
        },
      // },
      "& .Mui-disabled	": {
        background: "lightGray !important",
      },
      "& .MuiAvatar-root": {
        width: "100%",
        height: "100%",
        paddingLeft: "2px",
        paddingRight: "2px",
      },
    },
  }));

  const classes = useStyles();
  
  let allow = hasRoutePermission(route, role, permission);

  return allow ? (
    <div className={classes.button}>
      <Button
        variant={variant}
        className="shadow-none"
        color="primary"
        id={id}
        {...rest}
      >
        {rest.children}
      </Button>
    </div>
  ) : null;
}

const mapStateToProps = ({ role }) => ({
  role,
});

export default connect(mapStateToProps, null)(KisshtButton);

